/* Etiquette — PDP Description Accordion
   Reads the product description, splits on <h2> headings,
   wraps each heading + its following content into a collapsible row. */
(function () {
  function buildAccordion() {
    var desc = document.querySelector('.product__description');
    if (!desc || desc.dataset.etqAccordion === '1') return;

    var nodes = Array.from(desc.childNodes);
    var headings = desc.querySelectorAll('h2');
    if (!headings.length) return; // no sections — leave description as-is

    desc.dataset.etqAccordion = '1';

    var accordion = document.createElement('div');
    accordion.className = 'etq-accordion';

    var current = null; // current item's content container
    var firstItem = true;

    nodes.forEach(function (node) {
      var isH2 = node.nodeType === 1 && node.tagName === 'H2';
      if (isH2) {
        var titleText = node.textContent.replace(/\u00a0/g, ' ').trim();
        if (!titleText) return; // skip empty <h2></h2>

        var item = document.createElement('div');
        item.className = 'etq-accordion__item' + (firstItem ? ' is-open' : '');

        var header = document.createElement('button');
        header.type = 'button';
        header.className = 'etq-accordion__header';
        header.setAttribute('aria-expanded', firstItem ? 'true' : 'false');

        var title = document.createElement('span');
        title.className = 'etq-accordion__title';
        title.textContent = titleText;

        var icon = document.createElement('span');
        icon.className = 'etq-accordion__icon';

        header.appendChild(title);
        header.appendChild(icon);

        var content = document.createElement('div');
        content.className = 'etq-accordion__content';
        var inner = document.createElement('div');
        inner.className = 'etq-accordion__content-inner';
        content.appendChild(inner);

        header.addEventListener('click', function () {
          var willOpen = !item.classList.contains('is-open');
          // close all rows first
          accordion.querySelectorAll('.etq-accordion__item').forEach(function (it) {
            it.classList.remove('is-open');
            var h = it.querySelector('.etq-accordion__header');
            if (h) h.setAttribute('aria-expanded', 'false');
          });
          // open the clicked one (if it was closed)
          if (willOpen) {
            item.classList.add('is-open');
            header.setAttribute('aria-expanded', 'true');
          }
        });

        item.appendChild(header);
        item.appendChild(content);
        accordion.appendChild(item);

        current = inner;
        firstItem = false;
      } else if (current) {
        // content belongs to the current section
        current.appendChild(node.cloneNode(true));
      }
      // nodes before the first <h2> are dropped (usually whitespace)
    });

    // Replace the raw description with the accordion
    desc.innerHTML = '';
    desc.appendChild(accordion);
  }

  if (document.readyState !== 'loading') { buildAccordion(); }
  else { document.addEventListener('DOMContentLoaded', buildAccordion); }
  document.addEventListener('shopify:section:load', buildAccordion);
})();